import { SET_LIST_GAME_ACTION } from "../actions/GamePageAction/actionTypes";

const initialState = {
	games: []
};

const gamePageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LIST_GAME_ACTION: {
			return {
				...state,
				games: action.params
			};
		}

		default:
			return state;
	}
};

export default gamePageReducer;
